import { AdminDashboardList, Loading } from '@components'
import { FEATURE } from '@constants'
import { hasFeature } from '@helpers/dashboard'
import { useGetAdminDashboardList, useGetFeatures, useNavigation } from '@hooks'

const AdminDashboardListContainer = () => {
  const { isLoading, data: adminDashboardList } = useGetAdminDashboardList()
  const {isLoading: isFeatureLoading, data: featureList} = useGetFeatures()
  const { goToAdminDashboardDetail } = useNavigation()

  if (isLoading || isFeatureLoading) {
    return <Loading />
  }

  const isAllowUpdateStatus = hasFeature(featureList, FEATURE.DASHBOARD_MANAGEMENT)

  return (
      adminDashboardList && (
        <AdminDashboardList adminDashboardList={adminDashboardList} handleClickDashboardCard={goToAdminDashboardDetail} isAllowUpdateStatus={isAllowUpdateStatus} />
      )
  )
}

export default AdminDashboardListContainer
